import { client } from '../gen/client.gen';
import paramsSerializer from './paramSerializer';

client.setConfig({
  baseURL: import.meta.env.VITE_API_URL,
  paramsSerializer,
  withCredentials: true // Required for sending cookies with requests
});

type AuthErrorCallback = () => void;

let onAuthErrorCallback: AuthErrorCallback | undefined;
let isRedirecting = false;

export const resetAxiosAuthRedirectFlag = () => {
  isRedirecting = false;
};

export const setupAxiosAuthErrors = (onAuthError: AuthErrorCallback) => {
  // Prevent setting up multiple times
  if (onAuthErrorCallback) {
    return;
  }

  onAuthErrorCallback = onAuthError;

  client.instance.interceptors.response.use(
    res => res,
    err => {
      if (err.response?.status === 401 && !isRedirecting) {
        isRedirecting = true;

        if (onAuthErrorCallback) {
          return onAuthErrorCallback();
        }
      }

      return Promise.reject(err);
    }
  );
};

export { client };
